import React, { useState } from 'react';
import vial from '../images/fiolka.png';

const artciles = [
  {
    title: 'Badania na rok 2020',
    content:
      'Obecnie trwają prace badawcze nad silnikami LMB mające na celu optymalizację konstrukcji pod kątem uzyskania najlepszych parametrów pracy.',
    collapsibleContent:
      'Badania prowadzi wynalazca wraz ze swoim zespołem badawczym w Laboratorium Mechatroniki Wydziału Mechanicznego Politechniki Lubelskiej.'
  },
  {
    title: 'Badania na rok 2019',
    content: '',
    collapsibleContent: ''
  }
];

const Research = () => {
  return (
    <section>
      <div className="research-container">
        {artciles.map((a, i) => (
          <Article article={a} key={i} />
        ))}
      </div>
    </section>
  );
};

const Article = props => {
  const [collapsed, setCollapsed] = useState(false);

  const { article } = props;

  return (
    <div className="research-content">
      <div className="research-header">
        <img src={vial} alt="logo" className="research-img" />
        <h2 className="research-h2">{article.title}</h2>
      </div>
      <div className="research-body">
        <article>
          <p className="research-p">{article.content} </p>
          <p
            className="research-p"
            style={{ display: this.state.collapsed ? 'block' : 'none' }}
          >
            {article.collapsibleContent}
          </p>
          <br />
          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            className="collapsible"
          >
            Czytaj dalej &nbsp; {this.state.collapsed ? '▲' : '▼'}
          </button>
        </article>
      </div>
    </div>
  );
};

export default Research;
